import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-common/src/components/upsell/assets/upsell_icon_purple.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')